// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--Kz6he";
export var fullWidthImage = "styles-module--fullWidthImage--8i2Wz";
export var text = "styles-module--text---lluF";
export var left = "styles-module--left--gJGor";
export var right = "styles-module--right--WJaVI";
export var image = "styles-module--image--eP+ba";
export var cta = "styles-module--cta--YXxN2";